import { render, staticRenderFns } from "./ActiveTagesordnungItems.vue?vue&type=template&id=89708078"
import script from "./ActiveTagesordnungItems.vue?vue&type=script&lang=js"
export * from "./ActiveTagesordnungItems.vue?vue&type=script&lang=js"
import style0 from "./ActiveTagesordnungItems.vue?vue&type=style&index=0&id=89708078&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports